import styled from "styled-components";

export const DashboardWrapper = styled.div`
  display: grid;
  padding: 30px 16px;
  gap: 16px;
  grid-template-columns: auto 244px;
`;